import { SVGProps, Ref, forwardRef } from 'react';

export const MegaphoneFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M6.8 3.42v7.827l-.86-.072.583 1.38c.605 1.431.907 2.148.646 2.69q-.08.166-.201.304c-.398.451-1.177.452-2.73.452-.99 0-1.485 0-1.838-.261a1.3 1.3 0 0 1-.202-.185c-.292-.327-.338-.82-.43-1.804l-.283-3.022c-.316-.077-.56-.182-.761-.35a2 2 0 0 1-.365-.396C0 9.468 0 8.756 0 7.333 0 5.913 0 5.2.36 4.686q.154-.223.364-.396c.483-.401 1.193-.46 2.61-.58z"
                fill="currentColor"
            />
            <path
                d="M8.2 3.19c1.551-.994 5.836-4.102 7.078-2.93C16 .942 16 2.5 16 5.613v3.442c0 3.113 0 4.67-.722 5.352-1.242 1.171-5.527-1.936-7.078-2.93z"
                fill="currentColor"
            />
        </g>
    </svg>
));
MegaphoneFilledSize16Glyph.displayName = 'MegaphoneFilledSize16Glyph';
